import {
    useEffect,
    useState,
    useCallback
} from 'react';
import React from 'react';

import deepEqual from 'deep-equal';
import i18next, { t } from 'i18next';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import styles from './Talents.module.css';
import TalentCard from './TalentCard/TalentCard';
import Pagination from '../Pagination/Pagination';
import BlockLoader from '../../../../components/UI/Loaders/BlockLoader';
import { SortIconList } from '../../../../assets/images/icons';
import { useGetSkillsHook } from '../../../../utils/utilityHooks';
import { getFavoriteTalents, getTalentsList } from '../../../../services/TalentsService';

function Talents({ per_page, max_pages, hide_url_params = false, filters = {}, handleSortbyChange, initialSortBy, onPageChange, setTalentCountry, setTalentGender, setTalentNationality, formik, ...props }) {
    const navigate = useNavigate();
    const location = useLocation();

    // const userToken = useSelector(state => state.user.token);
    const user = useSelector(state => state.user.user);

    const query = new URLSearchParams(location.search);
    const initialPage = parseInt(query.get('page')) || 1;

    const [loading, setLoading] = useState(true);
    const [paginationLoading, setPaginationLoading] = useState(false);
    const [page, setPage] = useState(initialPage);
    const [filtersList, setFiltersList] = useState(filters);
    const [totalPages, setTotalPages] = useState(0);
    const [count, setCount] = useState(0);
    const [talents, setTalents] = useState([]);
    const [favTalents, setFavTalents] = useState([]);
    const skills = useSelector((state) => state.user.skills);
    const [relevancyIndex, setEndRelevancyIndex] = useState(-1)
    let options = useGetSkillsHook()

    const currentLanguage = i18next.language;

    const updateURL = useCallback((params) => {
        delete params.include_ids;
        delete params.exclude_ids;

        const searchParams = new URLSearchParams(params);
        navigate(`?${searchParams.toString()}`);
    }, [navigate]);

    useEffect(() => {

        if (!deepEqual(filters, filtersList)) {
            setFiltersList(filters);
            setPage(1);

            if (!hide_url_params) {
                updateURL({ page: 1, ...filters });
            }
        }

    }, [filters, hide_url_params, filtersList, page, updateURL]);
    useEffect(() => {
        const MAX_RETRIES = 1000; // Maximum retries
        let retryCount = 0;
        const fetchJobs = (page, per_page, max_pages, filters,) => {
            getTalentsList(page, per_page, max_pages, filters, user)
                .then((response) => {
                    let getIndexOfRelevance = response?.talents.findIndex((item) => item.isRelevent == false)
                    setEndRelevancyIndex(getIndexOfRelevance)
                    setTalents(response.talents.map((talent) => {
                        if (talent.languages) {
                            talent.languages = talent.languages.map((language) => {
                                return {
                                    ...language,
                                    id: talent.user_id + '-' + language.languageCode
                                };
                            });
                        }

                        if (talent.skills) {
                            talent.skills = talent.skills.map((skill) => {

                                let skillData = skills?.filter((e) => e.value == skill.skill_code)[0]

                                if (skills?.length > 0 && skillData && Object.keys(skillData)?.length > 0) {
                                    return {
                                        ...skill,
                                        code: currentLanguage === "en" ? skillData.labelen : skillData.labelar,
                                        id: skill.user_id + '-' + skill.skill_code
                                    }
                                }
                                else {
                                    return {
                                        ...skill,
                                        code: skill.skill_code,
                                        id: skill.user_id + '-' + skill.skill_code
                                    }
                                };
                            });
                        }
                        // Handle subscription checks safely when user might not be logged in
                        if (user && user.account_type === 'employer' && (user.active_subscription || user.subscriptionStatus === 'active')) { }
                        else if (user && user.account_type === 'jobseeker' && user.verification_status === 'approved') { }
                        else { }
                        return talent;
                    }));
                    setCount(response.total);
                    setTotalPages(response.totalPages);
                    setLoading(false);
                    setPaginationLoading(false);
                })
                .catch((error) => {
                    if (error.error === 'out of shared memory' && retryCount < MAX_RETRIES) {
                        retryCount++;
                        console.log(`Retrying... Attempt ${retryCount}`);
                        fetchJobs(page, per_page, max_pages, filters,);
                    } else {
                        console.error('Failed to fetch jobs after retries:', error);
                        setLoading(false);
                        setPaginationLoading(false);
                    }
                });
        }
        if (page && per_page && filters) {
            fetchJobs(page, per_page, max_pages, filters,)
        }
    }, [page, skills, filtersList, per_page, user, currentLanguage, max_pages]);
// console.log(user.account_type,'__________user__________')
    useEffect(() => {
        if (user && user.id) {
            getFavoriteTalents(user.id, page, per_page, filters, user)
                .then((response) => {
                    setFavTalents(response.talents)
                })
                .catch((error) => {
                    console.log(error);
                });
        } else {
            // Set empty favorites if no user is logged in
            setFavTalents([]);
        }
    }, [page, skills, filtersList, user, per_page]);

    const handlePageChange = (value) => {
        setPage(value);
        setPaginationLoading(true);

        // Scroll to first card
        const target = document.querySelector('.pagination_scroll_target');
        if (target) {
            window.scrollTo(0, target.offsetTop);
        }

        if (!hide_url_params) {
            updateURL({ page: value, ...filtersList });
        }
    };
    let favList = location.state; // Retrieve the state data passed during navigation
    if (favList?.length > 0) {
        favList = favList?.map((item) => item.jobSeekerDetails)
    }
    const [sortBy, setSortBy] = useState(initialSortBy || 'relevance')
    return (
        <div {...props} className={styles.list}>
            <div className={styles.talentsHeader}>
                <div className={styles.titleContainer}>
                    <p className={styles.headerTitleBold}>{count.toLocaleString()}</p>
                    <p className={styles.headerTitle}>{t('talentsHeader.jobseekersMatchedYourCriteria')}</p>
                </div>

                <div className={styles.titleContainer}>
                    <img
                        src={SortIconList}
                        alt={t('talentsHeader.sortBy')}
                        className={styles.sortIcon}
                    />
                    <p className={` ${styles.headerTitle} ${styles.sortButton}`}>{t('talentsHeader.sortBy')}</p>
                    <p className={`${styles.headerTitleBold} ${styles.sortButton}`}>
                        <span className={`${(sortBy == 'relevance') ? `${styles.isBold} ${styles.headerTitleBold}` : styles.headerTitleBold}`}
                            onClick={() => {
                                setSortBy('relevance')
                                handleSortbyChange(`relevance`)
                            }}
                        >{t('jobs.relevance')}</span>
                        {' - '}
                        <span
                            className={`${(sortBy == 'newest') ? `${styles.isBold} ${styles.headerTitleBold}` : styles.headerTitleBold}`}
                            onClick={() => {
                                setSortBy('newest')
                                handleSortbyChange(`newest`)
                            }}
                            style={{ textTransform: "capitalize" }}
                        >{t('jobs.actively_looking')}</span>
                    </p>
                </div>
            </div>
            {
                talents && talents.map((talent, index) => {
                    return (
                        <React.Fragment key={talent.id || `talent-${index}`}>
                            {relevancyIndex == index &&
                                <div className={styles.otherJobsHeading}>
                                    {t(`Other_jobs`)}
                                </div>
                            }
                            <TalentCard
                                setFavTalents={setFavTalents}
                                page={page} per_page={per_page} filters={filters}
                                favTalents={favTalents} key={'talent-' + talent.id} talent={talent} 
                                disabled={paginationLoading}
                                setTalentCountry={setTalentCountry}
                                formik={formik}
                                setTalentGender={setTalentGender}
                                setTalentNationality={setTalentNationality}
                            />
                        </React.Fragment>
                    );
                })
            }

            {loading && (Array.from({ length: per_page }, (_, index) => {
                return <BlockLoader key={index} height={280} marginBottom={20} />;
            }))}

            {count === 0 && !loading && <div className={styles.no_results}>No candidates found</div>}

            {totalPages > 0 && <Pagination totalPages={totalPages} currentPage={page} onPageChange={handlePageChange} />}
        </div>
    );
}

export default Talents;